export const pluginID = 'gift-card-refund';
